import federacoes from '../dominios/federacoes'

export function getDominio() {
    const hostname = window.location.hostname;

    return {
        hostname,
        conf: federacoes[hostname] || federacoes.localhost
    };
}
